export default __webpack_public_path__ + "static/media/dxc_icon-06.913d907a.png";